import { isInOfficeHours } from '@btcdirect/functions/src/office-hours';
import { useApiCommunicator } from '@btcdirect/shared/src/composables/api/communicator';
import { Endpoints } from '@btcdirect/shared/src/composables/api/endpoints';
import { useLocale } from '@btcdirect/shared/src/composables/util/locale';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { PaymentMethod } from '@btcdirect/stores';
import { usePaymentMethodsStore } from '@btcdirect/stores/src/payment-methods';
import { setApplePaySupport } from './payment-methods/apple-pay';

interface PaymentMethodsResponse {
    paymentMethods: PaymentMethod[];
}

const { warn } = useLogger();

export default async function getPaymentMethods(): Promise<boolean> {
    const paymentMethodsStore = usePaymentMethodsStore();
    const { country } = useLocale();
    const { get } = useApiCommunicator(Endpoints.PAYMENT_METHODS);

    try {
        const result: PaymentMethodsResponse = await get({
            countryCode: country.value
        });

        const processedMethods = processPaymentMethods(result.paymentMethods);
        paymentMethodsStore.setPaymentMethods(processedMethods);

        return true;
    } catch (exception) {
        warn('An error occurred while retrieve payment methods');

        return false;
    }
}

function processPaymentMethods(paymentMethods: PaymentMethod[]): PaymentMethod[] {
    const applePay = paymentMethods.some((method: PaymentMethod) => method.code === 'applepay');
    if (applePay) {
        setApplePaySupport(paymentMethods);
    }

    const bankTransfer = paymentMethods.find((method) => method.code === 'bankTransfer');
    if (!!bankTransfer) {
        // Check if we're in the office hours
        bankTransfer.disabled = !isInOfficeHours();
    }

    return paymentMethods;
}
